var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"color":"blue-grey darken-4","left":_vm.left,"top":_vm.top,"right":_vm.right},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({attrs:{"color":"primary","dark":""}},on),[_vm._v("mdi-help-circle-outline")])]}}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }